export default __webpack_public_path__ + "static/media/tsilogo.ff9d0e43.png";